<template>
    <div class="upper">
      <img v-if="detailData.courseImg!==undefined" class="bigImg" :src="detailData.courseImg" alt="">
      <img v-else class="bigImg" src="../../../../static/image/default.png" alt="">
      <div class="rtCont">
        <div class="firstLine">
          <div class="title">{{detailData.subject}}</div>
          <el-tag style="vertical-align: top;" v-if="detailData.courseState==='2'" color="#00abad">未开始</el-tag>
          <el-tag style="vertical-align: top;" v-if="detailData.courseState==='3'" color="#f0a800">进行中</el-tag>
          <el-tag style="vertical-align: top;" v-if="detailData.courseState==='4'">已结束</el-tag>

          <div v-if="keyList.length !== 0 " class="spanKeys">
            <div class="spanKey1" v-for="(key,index) in keyList" :key="index">
              <div class="spanKey" >{{key}}</div>
              <div class="arrow"><span class="arrow_1">。</span></div>
            </div>
          </div>

        </div>
        <div class="secLine">
          <span class="iconfont icon-chakan"></span><i>观看{{detailData.lookNum}}</i>
          <span class="iconfont icon-pingjia"></span><i>评价{{detailData.evaluateNum}}</i>
          <span v-if="detailData.appreciateFlag==='0'" class="iconfont icon-dianzan"></span>
          <span v-else class="iconfont icon-yidianzan"></span>
          <i>点赞{{detailData.goodNum}}</i>
          <span v-if="detailData.collectFlag==='0'" class="iconfont icon-shoucang"></span>
          <span v-else class="iconfont icon-yishoucang"></span>
          <i>收藏{{detailData.collectNum}}</i>
        </div>
        <div class="thirdLine">
          <ul>
            <li>
              <div class="label">授课人&nbsp;:&nbsp;</div>
              <div class="subStant">{{detailData.teacherName}}</div>
            </li>
            <li>
              <div class="label" >课程时间&nbsp;:&nbsp;</div>
              <div class="subStant" v-if="detailData.teachType==='1'">{{detailData.courseTimeStr}}</div>
              <div class="subStant" v-if="detailData.teachType==='2'">永久</div>
            </li>
            <li>
              <div class="label">课程分类&nbsp;:&nbsp;</div>
              <div class="subStant">{{courseDesc}}</div>
            </li>
            <li>
              <div class="label">学科分类&nbsp;:&nbsp;</div>
              <div class="subStant">{{scienceDesc}}</div>
            </li>
            <li class="lastLine">
              <div class="label">课程简介&nbsp;:&nbsp;</div>
              <div class="subStant subBrief" :title="detailData.remark">{{changeRemark}}</div>
            </li>
          </ul>
        </div>

      <div v-if="this.$route.name != 'LookCourse'" style="margin-top:-4px;">
        <div class="startLearn" :class="starts ? '':'unable' " @click="startLearn">开始学习</div>
        <div class="startLearn startCollect" @click="switCollect">{{collect}}</div>
      </div>
      <div v-else>
        <div class="startLearn" :class="starts ? '':'unable' " @click="startLearn">进入课程</div>
      </div>
      <div v-if="xiajiaIcon" class="lower iconfont icon-yixiajia" ></div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {mapGetters} from 'vuex'
  import {message} from '@/common/js/messages'
  import {onShelfState,changeteachType} from '@/common/js/change'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  export default {
    computed: {
      ...mapGetters([
        'isCollect'
      ])
    },
    data() {
      return {
        collect: '收藏',
        starts:false,
        elips:false,
        changeRemark:'',
        // checkPath:true,
        scienceDesc:'',
        courseDesc:'',
        detailData: [],
        xiajiaIcon:false,
        keyList:[],//存放关键字列表
      }
    },
    props: {
      type: {
        type: String,
        default: ''
      },
      current:{
        type: String,
        default: '1'
      }
    },
    updated() {
      if(this.detailData.remark != undefined){
        this.maxSlice(this.detailData.remark)
      }
    },
    methods: {
      maxSlice(val){
        let lent = val.length
        if(lent > 99){
          let slicedTxt = val.slice(0,100) + '...'
          this.changeRemark = slicedTxt
        }else{
          this.changeRemark = val
        }
      },
      startLearn(){   //开始学习
      // if(this.$route.name === 'CourseEvaluat'){    //学生状态判断
        if((this.detailData.courseState === '3'  || this.detailData.courseState === '4' || this.detailData.courseState === '0') && this.detailData.onShelf === '2'){
          let CourseId = getLocalStorage('Id')
          window.open(`${window.BROWSER_URL}teachRoom?videoCenter&type=${this.current}&lessonId=${CourseId}`,'_blank')
        }else if( this.detailData.courseState === '2'){
          message('该课程还未开始哦')
        }else{
          return false
        }

      // }else if(this.$route.name === 'LookCourse'){  //老师状态判断

      // }


      },
      detailList(){   //详情列表数据
        let CourseId = getLocalStorage('Id')

        let params = {
          id: CourseId
        }
        http.post('/course/getCourseDetail.json', params).then(res => {
          var science = ''
          var course = ''

          if (res.data.code === _.ERR_OK) {
            this.detailData = res.data.model
            course = res.data.model.courseTypeId
            // console.log(this.detailData.onShelf)
            if((this.detailData.courseState === '3'  || this.detailData.courseState === '4' || this.detailData.courseState === '0') && this.detailData.onShelf === '2'){
             //0自主学习 3进行中  4已结束  ---  1未上架 2已上架
              this.starts = true
            }else{
              this.starts = false
            }
            //获取关键词
            const keywords = this.detailData.keyWord;
            if(keywords && keywords.length>0){
              if(keywords.indexOf("，") !== -1){
                this.keyList = keywords.split("，");
              }else{
                this.keyList = keywords.split(",");
              }
            }

            let c = {typeId:'EDU_COURSETYPE'}
            http.post('/system/queryEduContantByTypeId.json', c ).then(res => {
                      if (res.data.code === _.ERR_OK) {
                          for(let i of res.data.model){
                            if(i.consId === course){
                              this.courseDesc = i.consDesc
                            }
                          }
                      }
            }).catch(() => {
            })


            if(res.data.model.scienceTypeId !== undefined){
              science = res.data.model.scienceTypeId
               let p = {typeId:'EDU_SUBJECTTYPE'}
                http.post('/system/queryEduContantByTypeId.json', p ).then(res => {
                      if (res.data.code === _.ERR_OK) {
                          for(let i of res.data.model){
                            if(i.consId === science){
                              this.scienceDesc = i.consDesc
                            }
                          }
                      }
                }).catch(() => {
                })

            }else{
              this.scienceDesc = '所有'
            }

            this.$emit('ifShow', res.data.model.starGrade)
            this.$emit('onShelf', res.data.model.onShelf)
            if(this.detailData.collectFlag==='0'){
              this.collect = '收藏'
            } else {
              this.collect = '已收藏'
            }

            if(this.detailData.onShelf ==='1' &&  this.$route.name != 'LookCourse'){
              this.xiajiaIcon = true
            }else{
              this.xiajiaIcon = false
            }


          } else {

          }

        }).catch(() => {

        })

      },
      switCollect(){
        if(this.collect ==='收藏'){
          this.collectInter('1')
          this.collect = '已收藏'
        } else if(this.collect === '已收藏'){
          this.collectInter('0')
          this.collect = '收藏'
        }
      },
      collectInter(val){
        let CourseId = getLocalStorage('Id')
        let params = {
          courseId: CourseId,
          operateType: val
        }
        http.post('/studyCenter/collectCourse.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            // this.detailData = res.data.model
            if(this.collect === '已收藏'){
              message('收藏成功', true)
              this.detailList()
            } else if(this.collect === '收藏'){
              message('已取消收藏', true)
              this.detailList()
            }
          } else {

          }
        }).catch(err => {
        })
      }

    },
    created() {
      const that = this;
      this.$events.$on("toLookCourse",()=>{
        that.detailList();
      });
      this.detailList()
      // if(this.$route.path == '/CourseEvaluat'){

      // }
    },
    beforeDestroy(){
      this.$events.$off("toLookCourse");
    },
    watch: {
      $route(to, from) {
        // console.log(to);
        // console.log(from);
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .arrow_1{
    position: absolute;
    left: -14px;
    top: -12px;
    color: #fff;
  }
  .arrow{
    border: 13px solid #fff;
    border-left-color: #d7e6f5;
    width: 0;
    height: 0;
    position: relative;
    left: -5px;
    display: inline-block;
    vertical-align: top;
  }
  .spanKey1{
    display: inline-block;
    margin-right: -7px;
  }
  .spanKey{
      background: #d7e6f5;
      padding: 5px 8px;
      top: 7px;
      border-radius: 0px;
      cursor: pointer;
      min-width: 40px;
      display: inline-block;
      text-align: center;
      font-weight: 550;
      vertical-align: top;
  }
  .spanKeys{
    color: #46494e;
    display: inline-block;
    margin-left: 10px;
  }

  .elips
    line-height 23px
    vertical-align:bottom
    color #000

  .upper
    background: $color-background-d
    height: 210px
    padding: 20px
    overflow: hidden
    position: relative
    .lower
      position: absolute
      right: 5px
      font-size: 79px !important
      top: 35px
    .bigImg
      width: 400px
      height: 210px
      float: left
      margin-right: 30px
    .rtCont
      float: left
      width: calc(100% - 430px)
      height: 100%
      position: relative
      .firstLine
        overflow: hidden
        margin: -10px 0 12px
        .title
          color: #000000
          font-size: 18px
          font-weight: bold
          float: left
          margin-right: 13px
          line-height: 23px
      .secLine
        i
          position: relative
          top: -2px
          left: 3px
          margin-right: 20px
          font-size: 13px
      .thirdLine
          margin-top: 8px
          ul
            overflow: hidden
            li
              float: left
              width: 42%
              line-height: 28px
              .label
                width: 75px
                text-align: right
                float: left
                margin: 0 10px 0 -3px
              .subStant
                width: calc(100% - 100px)
                color: #000
                float: left
            .lastLine
                width: 100%
      .startLearn
        position: absolute
        bottom: -1px
        left: 0
        width: 110px
        height: 32px
        line-height: 32px
        text-align: center
        background: $color-green
        color: #fff
        cursor: pointer
      .startLearn.unable
        background $button-del

      .startCollect
          left: 130px
</style>



// WEBPACK FOOTER //
// upper.vue?1426e7d5